import { Input, Table, Button, Popconfirm } from "antd";
import React, { useState } from "react";
import { getCurrentDateTimeInFormat } from "../../../helper/date_helper";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import debounce from "lodash.debounce";

function FolderPathNew(props) {
  const [dataSource, setDataSource] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});

  const updateDataSource = (key, value, record) => {
    const updatedData = dataSource.map((item) =>
      item.key === record.key ? { ...item, [key]: value } : item
    );
    setDataSource(updatedData);
    debouncedUpdateParent(updatedData);
  };
  const validateFields = () => {
    let errors = {};
    dataSource.forEach((item) => {
      if (!item.description) {
        errors[item.key] = { ...errors[item.key], description: true };
      }
      if (!item.comment) {
        errors[item.key] = { ...errors[item.key], comment: true };
      }
    });
    setValidationErrors(errors);
    return Object.keys(errors).length === 0; // Returns true if no errors
  };
  const handleAdd = () => {
    if (validateFields()) {
      const newData = {
        key: Date.now().toString(),
        dataType: "Environment",
        dataSubType: props.environmentName,
        name: "Folder Path",
        description: "",
        comment: "",
        createdDate: getCurrentDateTimeInFormat(),
      };
      setDataSource([...dataSource, newData]);
      props.onFolderUpdate(dataSource);
    }
  };
  const handleDelete = (key) => {
    setDataSource((prev) => prev.filter((item) => item.key !== key));
    props.onFolderUpdate(dataSource);
  };
  const handleDisplayNameChange = (value, record) => {
    updateDataSource("description", value, record);
    setValidationErrors((prev) => ({
      ...prev,
      [record.key]: { ...prev[record.key], description: !value },
    }));
    props.onFolderUpdate(dataSource);
  };
  const handlePathChange = (value, record) => {
    updateDataSource("comment", value, record);
    setValidationErrors((prev) => ({
      ...prev,
      [record.key]: { ...prev[record.key], comment: !value },
    }));
    props.onFolderUpdate(dataSource);
  };
  const debouncedUpdateParent = debounce((data) => {
    props.onFolderUpdate(data);
  }, 300);

  const columns = [
    {
      title: "",
      dataIndex: "delete",
      key: "delete",
      width: "4%",
      render: (_, record) => (
        <Popconfirm
          title="Are you sure?"
          onConfirm={() => handleDelete(record.key)}
        >
          <DeleteOutlined style={{ color: "red" }} />
        </Popconfirm>
      ),
    },
    {
      title: "Display Name",
      dataIndex: "description",
      key: "description",
      width: "30%",
      editable: true,
      render: (_, record) => (
        <>
          <Input
            style={{
              fontSize: "12px",
              borderColor: validationErrors[record.key]?.description
                ? "red"
                : undefined,
            }}
            onChange={(e) => handleDisplayNameChange(e.target.value, record)}
            placeholder="Enter Display Name"
            maxLength={50}
          />
          {validationErrors[record.key]?.description && (
            <div style={{ color: "red", fontSize: "12px" }}>
              Display Name is required
            </div>
          )}
        </>
      ),
    },
    {
      title: "Path",
      dataIndex: "comment",
      key: "comment",
      width: "50%",
      editable: true,
      render: (_, record) => (
        <>
          <Input
            style={{
              fontSize: "12px",
              borderColor: validationErrors[record.key]?.comment
                ? "red"
                : undefined,
            }}
            onChange={(e) => handlePathChange(e.target.value, record)}
            placeholder="Enter Folder Path"
          />
          {validationErrors[record.key]?.comment && (
            <div style={{ color: "red", fontSize: "12px" }}>
              Folder Path is required
            </div>
          )}
        </>
      ),
    },
  ];
  return (
    <div>
      <Table
        columns={columns}
        dataSource={dataSource}
        scroll={{ y: 300 }} // Set max height for scrollable table
        pagination={false}
        className="custom-table-shadow"
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: 16,
          position: "sticky",
          bottom: 0,
        }}
      >
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleAdd}
          className="db-add"
        >
          Add Path
        </Button>
      </div>
    </div>
  );
}

export default FolderPathNew;
